export class BadRequestError extends Error {
  code: number;

  constructor(message: string) {
    super(message);
    this.name = "Bad Request";
    this.code = 400;
  }
}
